import {
  fetchInvoice,
  postPaymentTransactionDoPayment,
  savePaymentTransaction
} from "shadow-client/endpoints/accountingApi";
import validCartToSale from "./validCartToSale";

const basRedirectUrl = process.env.REACT_APP_REDIRECT_PAYMENT_URL;

const doPayment = (contactId, saleId) => async (dispatch, getState) => {
  const saleResponse = await dispatch(validCartToSale(contactId, saleId));
  const invoiceResponse = await dispatch(fetchInvoice(saleResponse.get("invoiceId")));

  const webRedirectUrl = `${basRedirectUrl}/checkout_response`;

  const paymentTransactionResponse = await dispatch(
    savePaymentTransaction(null, {
      contactId: contactId,
      amount: invoiceResponse.get("amountToPayImmediately"),
      currency: invoiceResponse.get("priceCurrency"),
      clubId: invoiceResponse.get("clubId"),
      clubCode: invoiceResponse.get("clubCode"),
      saleId: invoiceResponse.get("saleId"),
      invoice: invoiceResponse.get("@id"),
      webRedirectUrl
    })
  );

  return paymentTransactionResponse;
};

export const getResponseDoPayment = urlPayId => async (dispatch, getState) => {
  const responseDoPayment = await dispatch(postPaymentTransactionDoPayment(urlPayId));
  return responseDoPayment;
};

export default doPayment;



// WEBPACK FOOTER //
// ./src/app/redux/actions/doPayment.js